import React, { useEffect, useRef, useState } from "react";
import { AthleteDTO } from "../../../interfaces/AthletesDTO";
import { TimeEvent, eventBus } from "../../../services/eventHandler";
import { TimeDTO } from "../../../interfaces/TimeDTO";
import {
  GetDateDifffromNowString,
  GetDiff,
  GetDifffromNow,
  GetDifffromNowString,
  formatDateTime,
  formatTime,
} from "../../../services/timeHandler";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import { useFavorites } from "../../../services/FavoritesProvider";
import { ShootingsDTO } from "../../../interfaces/ShootingsDTO";
import moment from "moment";
import { useClock } from "../../../services/ClockProvider";
import { useBlade } from "../../../services/BladeProvider";
import { UserTypes } from "../../../interfaces/internal/UserType";
import ResultRowAnalytics from "./Analytics/ResultRowAnalytics";
import { useResultTable } from "../../../services/ResultTableProvider";

interface Props {
  athlete: AthleteDTO;
  ipos: number;
  vType: ViewType;
  race: RaceDTO;
  afterShootnr: number;
  leg: number;
}
const StatusOkay: string[] = ["OK", "ENT", "START", "LL", "REMOVELL"];

const ResultRow = ({
  athlete,
  ipos,
  vType,
  race,
  afterShootnr,
  leg,
}: Props) => {
  const runtTimeRef = useRef<number | null>(null);

  const [athletes, setAthletes] = useState(athlete);
  const [timPenalty, setTimePenalty] = useState<number>(
    race.Class[athlete.ClassID].ShootTimePenalty
  );
  const [misses, setMisses] = useState<number>(0);
  const [extraShoot, setExtraShoot] = useState<number>(0);

  const [tim, setTim] = useState<TimeDTO | null>(null);
  const [preTim, setPreTim] = useState<TimeDTO | null>(null);
  const [markPassing, setMarkPassing] = useState<boolean>(false);
  const [markStatus, setMarkStatus] = useState<boolean>(false);
  const [order, setOrder] = useState<number | null>(null);
  const [runtTime, setRunTime] = useState<string | null>(null);
  const [diffTime, setDiffTime] = useState<string | null>(null);
  const [counter, setCounter] = useState<number>(0);
  const [forceRender, setForceRender] = useState(0);
  const [resAnalytics, setResAnalytics] = useState<JSX.Element | null>(null);
  const { favorites, addFavorite, removeFavorite } = useFavorites();
  const [timeFormat, setTimeFormat] = useState("T");
  const [athleteStatus, setAthleteStatus] = useState<string>("START");
  const { getUserType } = useBlade();
  const { getMomentUTCDiff, getMomentDiff,clockDiff } = useClock();
  const { setAnalytic, getAnalytic } = useResultTable();
  const [topRowWidth, setTopRowWidth] = useState(0);
  const [isRelay, setIsRelay] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const isFavorite = favorites.some((fav) => fav === athlete.ID);
  const missesRef = useRef<number>(0);
  const topRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);

  const diffTimeServer = useRef<number>(0);

  const { getWidthRow } = useResultTable();

  useEffect(() => {
    // console.log(ipos);
    // Here's your "hook by ID"
    // handleShooting();
    // console.log(athletes.Times);
    setAthleteStatus(athlete.Status);
    if (
      vType !== ViewType.stage &&
      (athletes.Times == undefined ||
        athletes.Times == null ||
        !(ipos in athletes.Times))
    ) {
      if (vType == ViewType.resultPretime && race != null) {
        // console.log(vType,athletes.Times,race);

        let prePos =
          race.Class[athlete.ClassID].Level[athlete.Level].TimePos[ipos];
        if (prePos != undefined && prePos != null) {
          if (prePos.PreTime != undefined && prePos.PreTime != null) {
            if (prePos.PreTime.Ipos in athlete.Times) {
              // console.log(prePos);
              setPreTim(athlete.Times[prePos.PreTime.Ipos]);
              setOrder(athlete.IposRankSortOrder[ipos]!.order);
              // console.log("first if",athlete.Times[prePos.PreTime.Ipos].RankPreTiming,athlete.Times[prePos.PreTime.Ipos].Startno);
            }
          }
        }
      }
      // setHTMLContent(updateContent);
    } else if (Math.abs(ipos) in athletes.Times) {
      setTim(athletes.Times[Math.abs(ipos)]);
      if (vType === ViewType.scroll) {
        setOrder(athletes.Times[Math.abs(ipos)].ID * -1);
      } else if (vType === ViewType.stage) {
        setOrder(athletes.Times[Math.abs(ipos)].RankClass);
      } else {
        setOrder(athlete.IposRankSortOrder[ipos]!.order);
      }

      // console.log("first if",athlete.Times[ipos].RankPreTiming,athlete.Times[ipos].Startno);
    } else {
      // console.log("debug_unkwon");
    }
    const handlerFavorite = (ath: AthleteDTO) => {
      if (isFavorite) {
        removeFavorite(athlete.ID);
      } else {
        addFavorite(athlete.ID);
      }
    };
    const handlerTime = (_time: TimeEvent) => {
      //  console.log(_time.messageType,_time);
      //console.log(_time,_time.startno,_time.time?.Startno,_time.time?.Ipos,ipos);
      if (_time.messageType == "delete") {
        setTim(null);
        setOrder(null);
      } else if (_time.messageType == "deletePre") {
        setPreTim(null);
        if (!tim) {
          setOrder(null);
        }
        // console.log(tim, preTim);
      } else if (_time.messageType == "add" && _time.time) {
        setPreTim(null);
        setTim(_time.time);
        if (vType == ViewType.scroll) {
          setOrder(athletes.Times[Math.abs(ipos)].ID * -1);
        } else {
          setOrder(_time.order);
        }
        if (tim === null) {
          setForceRender((prev) => prev + 1);
        } else if (
          _time.time.RankClass !== tim?.RankClass ||
          _time.time.DiffClass !== tim.DiffClass
        ) {
          setForceRender((prev) => prev + 1);
        }

        // console.log("Settings pretime",_time,_time.startno);
      } else if (
        _time.messageType == "addPre" &&
        tim == null &&
        _time.time != null &&
        vType === ViewType.resultPretime
      ) {
        // setPreTim(prevPreTim => (...setPreTim));
        if (_time.runtTimeTobeat !== null) {
          _time.time.RunTimeTobeat = _time.runtTimeTobeat;
        }
        setPreTim(_time.time);
        setOrder(_time.order);
        // setOrder(_time.time.RankPreTiming);
        // console.log("Settings pretime",_time,_time.startno);
      } else if (_time.messageType == "uppdate" && _time.time) {
        setPreTim(null);
        setTim(_time.time);
        vType === ViewType.resultPretime
          ? setOrder(_time.time.RankPreTiming)
          : setOrder(_time.time.RankClass);
        // console.log("first if",_time.time.RankPreTiming);
      } else if (_time.messageType == "changedstatus") {
        // setTim(null)
      } else if (_time.messageType == "changedstarttime") {
        // setTim(null)
      } else {
        // console.log("No match :" + _time.messageType);
      }

      // setCounter((counter) => (counter + 1));
    };
    const handlerShooting = (sht: ShootingsDTO | null) => {
      handleShooting();
    };
    const handlerStatus = (status: string) => {
      setAthleteStatus(status);
    };
    eventBus.on(
      `shooting_changed_${athletes.ClassID}_${athletes.Level}_${athletes.Startno}`,
      handlerShooting
    );
    eventBus.on(
      `tim_${athletes.ClassID}_${athletes.Level}_${Math.abs(ipos)}_${
        athletes.Startno
      }`,
      handlerTime
    );
    // eventBus.emit(`at_status_${classId}_${level}_${startno}`, status);

    eventBus.on(
      `at_status_${athletes.ClassID}_${athletes.Level}_${athletes.Startno}`,
      handlerStatus
    );

    startInterval();
    updateInterval();
    setTimeFormat(race.Class[athlete.ClassID].TimeFormat);
    handleShooting();

    if (athlete) {
      if (race.Class[athlete.ClassID].Discipline.includes("Stafett") || race.Class[athlete.ClassID].Discipline.includes("Sprintstafett")) {
        setIsRelay(true);
      }
    }

    return () => {
      // Cleanup to avoid memory leaks
      if (runtTimeRef.current !== null) {
        window.clearInterval(runtTimeRef.current);
        runtTimeRef.current = null;
      }
      // if (resizeObserver) {
      //   resizeObserver.disconnect();
      // }

      eventBus.removeListener(
        `shooting_changed_${athletes.ClassID}_${athletes.Level}_${athletes.Startno}`,
        handlerShooting
      );
      eventBus.removeListener(
        `at_status_${athletes.ClassID}_${athletes.Level}_${athletes.Startno}`,
        handlerStatus
      );
      eventBus.removeListener(
        `tim_${athletes.ClassID}_${athletes.Level}_${Math.abs(ipos)}_${
          athletes.Startno
        }`,
        handlerTime
      );
    };
  }, []);
  useEffect(() => {
    diffTimeServer.current = clockDiff;
  }, [clockDiff])

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.style.width = `${topRowWidth}px`;
    }
  }, [topRowWidth]);

  const startInterval = () => {
    if (runtTimeRef.current !== null) return;
    runtTimeRef.current = window.setInterval(() => {
      updateInterval();
    }, 1000);
  };

  const updateInterval = () => {
    if (ipos === 0) {
      let stTim = getMomentDiff(diffTimeServer.current).diff(
        moment(
          athlete.UsedStartTime === null
            ? athlete.StartTime
            : athlete.UsedStartTime
        )
      );
      // console.log(stTim);
      if (!StatusOkay.includes(athlete.Status)) {
        setRunTime(athlete.Status);
        setMarkStatus(true);
      } else if (athlete.Status === "OK") {
        if (999 in athlete.Times) {
          // formatTime(tim.RunTime, timeFormat)
          setRunTime(formatTime(athlete.Times[999].RunTime, timeFormat));
        } else {
          setRunTime("");
        }
        setMarkStatus(false);
      } else {
        if (Math.abs(stTim) < 10 * 1000) {
          setMarkPassing(true);
        } else {
          setMarkPassing(false);
        }
        if (stTim < 0) {
          setRunTime(
            "-" +
              formatTime(moment(Math.abs(stTim)).utc().format("HH:mm:ss"), "S")
          );
        } else {
          setRunTime(
            formatTime(moment(Math.abs(stTim)).utc().format("HH:mm:ss"), "S")
          );
        }
        setMarkStatus(false);
      }
    }
  };

  useEffect(() => {
    // setHTMLContent(updateContent);
    if (tim !== null) {
      let tDif = GetDifffromNow(tim.PassTime);
     tDif = tDif + diffTimeServer.current;
      const redDelaySecond = 20;
      if (tDif / 1000 < redDelaySecond) {
        setMarkPassing(true);
        const timeoutId = setTimeout(() => {
          setMarkPassing(false);
        }, redDelaySecond * 1000 - tDif / 1000);
        // Clear the timeout when the component is unmounted
        return () => clearTimeout(timeoutId);
      }
    }
  }, [tim]);

  useEffect(() => {
    let intervalId: any;
    if (preTim != null) {
      // Set up an interval to update the currentTime state every second
      let shootingPenalty =
        missesRef.current * race.Class[athlete.ClassID].ShootTimePenalty;
      intervalId = setInterval(() => {
        let rTim: string =
          athlete.UsedStartTime === null
            ? GetDateDifffromNowString(athlete.StartTime, "S", shootingPenalty)
            : GetDateDifffromNowString(
                athlete.UsedStartTime,
                "S",
                shootingPenalty
              );
        if (athlete.IposRankSortOrder[ipos] !== null) {
          if (athlete.IposRankSortOrder[ipos]!.timetobeat === null) {
            setDiffTime(null);
          } else if (
            getUserType() === UserTypes.TvSpotter &&
            athlete.IposRankSortOrder[ipos]!.timetopass
          ) {
            let Stim: Date =
              athlete.UsedStartTime === null
                ? athlete.StartTime
                : athlete.UsedStartTime;
            let runTim = moment(getMomentUTCDiff(diffTimeServer.current).diff(moment(Stim).utc()))
              .utc()
              .format("HH:mm:ss.SS"); //("HH:mm:ss.SS");
            let diff = GetDiff(
              runTim,
              athlete.IposRankSortOrder[ipos]!.timetopass!
            );
            if (diff !== diffTime) {
              setDiffTime("*" + diff);
            }
          } else {
            let Stim: Date =
              athlete.UsedStartTime === null
                ? athlete.StartTime
                : athlete.UsedStartTime;
            let runTim = moment(getMomentUTCDiff(diffTimeServer.current).diff(moment(Stim).utc()))
              .utc()
              .format("HH:mm:ss.SS"); //("HH:mm:ss.SS");
            let diff = GetDiff(
              runTim,
              athlete.IposRankSortOrder[ipos]!.timetobeat!
            );
            if (diff !== diffTime) {
              setDiffTime(diff);
            }
          }
        } else {
          setDiffTime(null);
        }
        setRunTime(rTim);
      }, 1000);
    }
    // Clear the interval when the component is unmounted or preTim changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [preTim]);

  const handleClick = () => {
    eventBus.emit(`selctedathlete`, athlete);
    let styleElement = document.getElementById("web-selected-style");
    // adjustWidth();
    if (styleElement) {
      styleElement.textContent = `[data-athleteid="${athlete.ID}"] { background: rgb(128 128 128 / 40%)  !important; }`;
    }
    if (getUserType() === UserTypes.Trainer) {
      if (getAnalytic(athlete.ID)) {
        // setResAnalytics(null);
        setAnalytic(-1);
      } else {
        setAnalytic(athlete.ID);

        // setResAnalytics(
        //   <ResultRowAnalytics athlete={athlete} ipos={ipos} race={race} />
        // );
      }
    }
  };
  useEffect(() => {
    if (!getAnalytic(athlete.ID)) {
      setResAnalytics(null);
    } else {
      setResAnalytics(
        <ResultRowAnalytics athlete={athlete} ipos={ipos} race={race} />
      );
    }
  }, [getAnalytic(athlete.ID)]);

  const handlerFavorite = () => {
    if (isFavorite) {
      removeFavorite(athlete.ID);
    } else {
      addFavorite(athlete.ID);
    }
  };
  const handleShooting = () => {
    let misses = 0;
    let extraShoot = 0;

    Object.keys(athlete.Shooting).map((key) => {
      if (parseInt(key) <= afterShootnr) {
        misses += athlete.Shooting[parseInt(key)].Missed;
        extraShoot += athlete.Shooting[parseInt(key)].UsedExtra ?  athlete.Shooting[parseInt(key)].UsedExtra! : 0;
      }
    });
    setMisses(misses);
    setExtraShoot(extraShoot);
  };
  useEffect(() => {
    missesRef.current = misses;
  }, [misses]);

  const getTemMember = (): string => {

    if (athlete) {
      
      if (leg in athlete.RealyAthletes && leg > 0) {
        return athlete.RealyAthletes[leg].FormatedShortName;
      }
      else if (ipos === 0){
        let relNam = "";
        Object.keys(athlete.RealyAthletes).map((key) =>{
          relNam += athlete.RealyAthletes[parseInt(key)].LastName + ",";
        })
        return relNam;
      }
    }
    return "";
  };

  const commonJSX: JSX.Element = (
    <>
      <div className="resultrowdata resultrowbib clbib">
        <span>{athlete.Startno}</span>
      </div>
      <div className="resultrowdata resultrowshortname clshortname">
        <span>{isRelay ? athlete.FormatedName : athlete.FormatedShortName}</span>
      </div>
      <div className="resultrowdata resultrowname clname">
        <span>{athlete.FormatedName}</span>
      </div>
      <div className="resultrowdata resultrowflag clflag">
        <span
          style={{
            backgroundImage: `url(../../../img/flags/${athlete.Nation}.png)`,
          }}
        >
          &nbsp;
        </span>
      </div>
      <div className="resultrowdata resultrowteam clteam">
        <span>{isRelay ? getTemMember() : athlete.Club}</span>
      </div>
      <div className="resultrowdata resultrowrelay clrelay">
        <span>&nbsp;</span>
      </div>
      <div className="resultrowdata resultrowshooting clshootingstring">
        <span>&nbsp;</span>
      </div>
      <div
        className="resultrowdata resultrowshooting clshooting"
        style={
          afterShootnr === 0 ? { display: "none" } : { display: "table-cell" }
        }
      >
        <span>{misses}{isRelay ? "+" + extraShoot : ""}</span>
      </div>
    </>
  );
  // const updateContent = ():JSX.Element => {
  //   let htmData:JSX.Element;
  if (ipos === 0 || (ipos === -999 && !tim)) {
    return (
      <div
        data-key={counter}
        key={counter}
        style={{ order: athlete.Startno + 100000 }}
        className={
          "resultrow " +
          (isFavorite ? "result-row-favorite" : undefined) +
          (markPassing ? " row_last-passed " : "") +
          (markStatus ? " row_notok-status " : "")
        }
        data-bib={athlete.Startno}
        data-athleteid={athlete.ID}
        data-status={athleteStatus}
        onClick={handleClick}
      >
        <div className="resultrowdata-inner-row-top">
          <div
            className="resultrowdata resultrowrank clrank result-row-star"
            onClick={handlerFavorite}
          >
            <span>&nbsp;</span>
          </div>
          <div className="resultrowdata resultrowrank-bib clrank-clbib">
            <span>{athlete.Startno}</span>
          </div>
          {commonJSX}
          <div className="resultrowdata resultrowruntime clruntime">
            <span>
              {vType === ViewType.stage ? (
                <>&nbsp;</>
              ) : (
                <> {formatDateTime(athlete.StartTime, "S")}</>
              )}
            </span>
          </div>
          <div className="resultrowdata resultrowdiff cldifftime">
            <span>{runtTime === null ? <>&nbsp;</> : runtTime}</span>
          </div>
        </div>
        <div
          className="resultrowdata-inner-row-bottom"
          style={{ maxWidth: getWidthRow() }}
        >
          {null}
        </div>
      </div>
    );
  } else if (tim) {
    return (
      <div
        key={counter}
        data-key={counter}
        style={{
          order: order == null ? undefined : order,
          height: getAnalytic(athlete.ID) ? "56px" : undefined,
        }}
        className={
          "resultrow " +
          (markPassing ? "row_last-passed" : "") +
          (isFavorite ? "result-row-favorite" : "")
        }
        data-status={athleteStatus}
        data-bib={athlete.Startno}
        data-athleteid={athlete.ID}
        onClick={handleClick}
      >
        <div
          className="resultrowdata-inner-row-top"
          id={"resin" + athlete.Startno}
        >
          <div
            className="resultrowdata-inner-inner-row-top"
            id={"resinin" + athlete.Startno}
          >
            <div className="resultrowdata resultrowrank clrank">
              <span>
                {StatusOkay.includes(athlete.Status) ? tim.RankClass : ""}
              </span>
            </div>
            <div className="resultrowdata resultrowrank-bib clrank-clbib">
              <span>
                {StatusOkay.includes(athlete.Status) ? tim.RankClass : ""}
              </span>
            </div>
            {commonJSX}
            <div className="resultrowdata resultrowruntime clruntime">
              <span>
                {StatusOkay.includes(athlete.Status)
                  ? formatTime(tim.RunTime, timeFormat)
                  : athlete.Status}
              </span>
            </div>
            <div className="resultrowdata resultrowdiff cldifftime">
              <span>
                {StatusOkay.includes(athlete.Status)
                  ? formatTime(tim.DiffClass, timeFormat)
                  : ""}
              </span>
            </div>
          </div>
        </div>
        <div
          className="resultrowdata-inner-row-bottom"
          style={{ maxWidth: getWidthRow() }}
        >
          {resAnalytics}
        </div>
      </div>
    );
  } else if (preTim) {
    return (
      <div
        key={counter}
        data-key={counter}
        style={{
          order: order == null ? undefined : order,
          color: isFavorite ? "red" : undefined,
          height: getAnalytic(athlete.ID) ? "56px" : undefined,
        }}
        data-status={athleteStatus}
        className={
          "resultrow row_pretimed " +
          (isFavorite ? "result-row-favorite" : undefined)
        }
        data-bib={athlete.Startno}
        data-athleteid={athlete.ID}
        onClick={handleClick}
      >
        <div className="resultrowdata-inner-row-top">
          <div className="resultrowdata resultrowrank clrank">
            <span>
              P.{StatusOkay.includes(athlete.Status) ? preTim.RankClass : ""}
            </span>
          </div>
          <div className="resultrowdata resultrowrank-bib clrank-clbib">
            <span>
              P.{StatusOkay.includes(athlete.Status) ? preTim.RankClass : ""}
            </span>
          </div>
          {commonJSX}
          <div className="resultrowdata resultrowruntime clruntime">
            <span>
              {StatusOkay.includes(athlete.Status)
                ? formatTime(runtTime == null ? "" : runtTime, "S")
                : athlete.Status}
            </span>
          </div>
          <div className="resultrowdata resultrowdiff cldifftime">
            <span>{StatusOkay.includes(athlete.Status) ? diffTime : ""}</span>
          </div>
        </div>
        <div
          className="resultrowdata-inner-row-bottom"
          style={{ maxWidth: getWidthRow() }}
        >
          {resAnalytics}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
  // return htmData;
};

export default ResultRow;
